var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1834 81.9112C19.275 81.9112 8 70.6362 8 56.7278C8 42.8194 19.275 31.5444 33.1834 31.5444C36.1992 31.5444 39.0912 32.0745 41.7712 33.0466C47.059 20.1128 59.767 11 74.6035 11C94.1851 11 110.059 26.874 110.059 46.4556C110.059 47.3182 110.028 48.1737 109.968 49.0208C115.889 51.7474 120 57.7339 120 64.6805C120 74.1968 112.286 81.9112 102.769 81.9112H33.1834Z",
    fill: "#A3B6C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9543 95.7094L89.5148 88.5385L86.0752 95.7096C85.7339 96.3071 85.5385 97.0018 85.5385 97.7429C85.5385 99.9797 87.3187 101.793 89.5148 101.793C91.7109 101.793 93.4911 99.9797 93.4911 97.7429C93.4911 97.0017 93.2956 96.307 92.9543 95.7094Z",
    fill: "#2F85BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0255 110.29L77.5858 103.118L74.1465 110.289C73.805 110.887 73.6095 111.581 73.6095 112.323C73.6095 114.56 75.3897 116.373 77.5858 116.373C79.7819 116.373 81.5621 114.56 81.5621 112.323C81.5621 111.582 81.3667 110.887 81.0255 110.29Z",
    fill: "#2F85BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0964 95.7095L65.6568 88.5385L62.2173 95.7094C61.876 96.307 61.6805 97.0017 61.6805 97.7429C61.6805 99.9797 63.4607 101.793 65.6568 101.793C67.8529 101.793 69.6331 99.9797 69.6331 97.7429C69.6331 97.0018 69.4377 96.3071 69.0964 95.7095Z",
    fill: "#2F85BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8299 110.289L54.3905 103.118L50.9509 110.289C50.6097 110.887 50.4142 111.582 50.4142 112.323C50.4142 114.56 52.1945 116.373 54.3905 116.373C56.5866 116.373 58.3669 114.56 58.3669 112.323C58.3669 111.582 58.1713 110.887 57.8299 110.289Z",
    fill: "#2F85BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9012 95.7097L42.4616 88.5385L39.0221 95.7092C38.6807 96.3069 38.4852 97.0016 38.4852 97.7429C38.4852 99.9797 40.2655 101.793 42.4615 101.793C44.6576 101.793 46.4379 99.9797 46.4379 97.7429C46.4379 97.0018 46.2424 96.3073 45.9012 95.7097Z",
    fill: "#2F85BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.972 110.289L30.5325 103.118L27.093 110.289C26.7517 110.887 26.5562 111.582 26.5562 112.323C26.5562 114.56 28.3365 116.373 30.5325 116.373C32.7286 116.373 34.5089 114.56 34.5089 112.323C34.5089 111.582 34.3134 110.887 33.972 110.289Z",
    fill: "#2F85BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainLm);
export default __webpack_public_path__ + "static/media/rain-lm.1a5b1a2f9b19d134de74b90308a6505d.svg";
export { ForwardRef as ReactComponent };